import { memo } from "react";

import { LoginErrorContactButton as Button } from "./ContactButton";

// -----------------------------------------------------------------------------

export const LoginErrorMessage = memo(function LoginErrorMessage({
  errorMessage,
}: Props): JSX.Element {
  switch (errorMessage) {
    case "expired_or_already_used":
      return <>This login link expired or was already used.</>;

    case "organization_already_exists":
      return (
        <>
          Organization already exists, please contact your ThreatKey
          administrator for an invite.
        </>
      );

    case "new_user_error":
      return (
        <>
          An error occurred creating your account, <Button />
        </>
      );

    case "new_organization_error":
      return (
        <>
          An error occurred creating your organization, <Button />
        </>
      );

    case "signin_error":
    default:
      return (
        <>
          An error occurred signing you in, <Button />
        </>
      );
  }
});

// -----------------------------------------------------------------------------

interface Props {
  errorMessage: string;
}
